import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysEligibleCompaniesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysEligibleCompaniesController.php
* @route '/api/company/elys-eligible'
*/
const ElysEligibleCompaniesController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysEligibleCompaniesController.url(options),
    method: 'get',
})

ElysEligibleCompaniesController.definition = {
    methods: ["get","head"],
    url: '/api/company/elys-eligible',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysEligibleCompaniesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysEligibleCompaniesController.php
* @route '/api/company/elys-eligible'
*/
ElysEligibleCompaniesController.url = (options?: RouteQueryOptions) => {
    return ElysEligibleCompaniesController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysEligibleCompaniesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysEligibleCompaniesController.php
* @route '/api/company/elys-eligible'
*/
ElysEligibleCompaniesController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ElysEligibleCompaniesController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\Elys\ElysEligibleCompaniesController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/Elys/ElysEligibleCompaniesController.php
* @route '/api/company/elys-eligible'
*/
ElysEligibleCompaniesController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ElysEligibleCompaniesController.url(options),
    method: 'head',
})

export default ElysEligibleCompaniesController